import { type FC, useCallback } from 'react'

import { useUnit } from 'effector-react'

import { Button } from '@/components/ui/button.tsx'
import { Dialog } from '@/components/ui/dialog.tsx'
import type { DialogProps } from '@/dialogs/types'
import { $selectedMediaIds, deleteMediasFx } from '@/models/vault/medias'
import { toPlural } from '@/utils/helpers.ts'

interface Props extends DialogProps {}

export const DeleteMediaDialog: FC<Props> = ({ isOpen, onClose }) => {
  const selectedMediaIds = useUnit($selectedMediaIds)
  const isDeleteMediaLoading = useUnit(deleteMediasFx.pending)

  const handleDeleteClick = useCallback(async () => {
    await deleteMediasFx()
    onClose()
  }, [onClose])

  return (
    <Dialog
      show={isOpen}
      onClose={onClose}
    >
      <Dialog.Header>
        <Dialog.Title>Delete media</Dialog.Title>
      </Dialog.Header>

      <div className="mt-5">
        <p>
          Are you sure you want to permanently delete {selectedMediaIds.length}{' '}
          {toPlural(selectedMediaIds.length, 'item')}?
        </p>
      </div>

      <Dialog.Footer>
        <Button
          variant="outline"
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          onClick={handleDeleteClick}
          isLoading={isDeleteMediaLoading}
          variant="destructive"
        >
          Delete
        </Button>
      </Dialog.Footer>
    </Dialog>
  )
}
